<template>
  <div>
    <v-layout align-end row wrap>
      <v-flex shrink>
        <v-layout row wrap>
          <v-flex xs6>
            <div class="form-control" style="position: relative">
              <div class="labelinputontop">{{ $t('start_date') }}</div>
              <DatePickerWithoutButton v-model="selectedDate.start" @change="onChangeDate">
                <input :value="DateFormat(selectedDate.start)" readonly type="text" />
              </DatePickerWithoutButton>
            </div>
          </v-flex>
          <v-flex class="pl-2" xs6>
            <div class="form-control" style="position: relative">
              <div class="labelinputontop">{{ $t('end_date') }}</div>
              <DatePickerWithoutButton v-model="selectedDate.end" @change="onChangeDate">
                <input :value="DateFormat(selectedDate.end)" readonly type="text" />
              </DatePickerWithoutButton>
            </div>
          </v-flex>
        </v-layout>
      </v-flex>
      <v-flex style="display: flex; justify-content: flex-end">
        <v-btn dark depressed color="primary" @click="showAdvancedSearch = !showAdvancedSearch">
          <v-icon>search</v-icon>
          &nbsp;
          {{ $t('advanced search') }}&nbsp;
          <em v-if="!showAdvancedSearch" class="fas fa-angle-down" />
          <em v-else class="fas fa-angle-up" />
        </v-btn>
        <!-- <v-btn outline color="primary" @click="handleExportXlsx">
          <em class="fas fa-file-export" />&nbsp;{{ $t('export') }}
        </v-btn> -->
      </v-flex>
    </v-layout>

    <div
      v-if="showAdvancedSearch"
      class="my-4 py-2"
      style="border: 1px solid #eee; border-radius: 10px; position: relative"
    >
      <v-layout wrap class="form-control">
        <v-flex xs12 sm4 px-2>
          <div class="caption">{{ $t('Search') }}</div>
          <input v-model="filter.search" type="text" :placeholder="$t('Search')" />
        </v-flex>
        <v-flex xs12 sm4 px-2>
          <div class="caption">{{ $t('Created by') }}</div>
          <input v-model="filter.created_by" type="text" :placeholder="$t('Created by')" />
        </v-flex>
        <v-flex xs12 sm4 px-2>
          <div class="caption">{{ $t('status') }}</div>
          <multiselect
            v-model="filter.status"
            :options="statusOptions"
            select-label
            selected-label
            label="label"
            track-by="value"
          ></multiselect>
        </v-flex>

        <v-flex xs12 sm4 px-2>
          <div class="caption">สถานะรอง</div>
          <multiselect
            v-model="filter.sub_status"
            :options="subStatusOptions"
            select-label
            selected-label
            label="label"
            track-by="value"
          ></multiselect>
        </v-flex>

        <v-flex xs12 sm8 style="display: flex; align-items: flex-end; justify-content: flex-end">
          <v-btn outline color="grey" @click="handleClearSearch">{{ $t('Clear Search') }}</v-btn>
          <v-btn depressed color="primary" @click="handleSearch">
            <em class="fas fa-search mr-1"></em>
            {{ $t('Search') }}
          </v-btn>
        </v-flex>
      </v-layout>
    </div>

    <div class="text-xs-right mt-1" style="display: flex; align-items: baseline">
      <span class="mr-1">{{ $t('follow_up.total') }}:</span>
      <h3>{{ total }}</h3>
    </div>

    <v-data-table
      hide-actions
      :headers="tableHeader"
      :items="followUpTaskList"
      :pagination.sync="pagination"
      class="elevation-1 mt-2"
    >
      <template #items="props">
        <tr>
          <td>{{ props.item.start_date | DateFormat('DD/MM/YYYY') }}</td>
          <td>{{ props.item.first_name }} {{ props.item.last_name }}</td>
          <td><ChannelLabel :channel="props.item.app" /></td>
          <td>{{ props.item.subject || '-' }}</td>
          <td>{{ props.item.description || '-' }}</td>
          <td>{{ props.item.created_by || '-' }}</td>
          <td>{{ props.item.created_at | DateFormat('DD/MM/YYYY') }}</td>
          <td>
            <v-chip v-if="props.item.status === 'complete'" color="#c1e1c1" text-color="dark">{{
              $t('follow_up.status.complete')
            }}</v-chip>

            <v-chip v-else-if="props.item.status === 'pending'" color="#ffecb3" text-color="dark">{{
              $t('follow_up.status.pending')
            }}</v-chip>
            <v-chip
              v-else-if="props.item.status === 'in_progress'"
              color="#f0b582"
              text-color="dark"
              >{{ $t('follow_up.status.in_progress') }}</v-chip
            >
            <v-chip v-else-if="props.item.status === 'cancel'" color="#ef5350" text-color="dark">{{
              $t('follow_up.status.cancel')
            }}</v-chip>
          </td>
          <td>
            {{ props.item.sub_status ? $t(`follow_up.status.${props.item.sub_status}`) : '-' }}
          </td>
          <td>
            <v-btn icon color="primary" @click.stop="handleGoToLiveChat(props.item)">
              <v-icon small>chat</v-icon>
            </v-btn>
          </td>
        </tr>
      </template>
    </v-data-table>
    <div class="mt-2">
      <v-pagination
        v-model="pageNumber"
        :total-visible="6"
        :length="pageLength"
        @input="handleChangePage"
      ></v-pagination>
    </div>
  </div>
</template>

<script>
import kmbApi from '@/api/kmb'
import dayjs from 'dayjs'
import { mapGetters } from 'vuex'
import ChannelLabel from '@/components/elements/ChannelLabel.vue'
import DatePickerWithoutButton from '@/components/elements/DatePickerWithoutButton.vue'
import Multiselect from 'vue-multiselect'

export default {
  components: {
    ChannelLabel,
    DatePickerWithoutButton,
    Multiselect
  },
  data() {
    return {
      selectedDate: {
        start: dayjs().format('YYYY-MM-01'),
        end: dayjs().endOf('month').format('YYYY-MM-DD')
      },
      filter: {
        search: '',
        status: '',
        created_by: '',
        sub_status: ''
      },
      followUpTaskList: [],
      total: 0,
      limit: 20,
      offset: 0,
      pagination: { rowsPerPage: -1, sortBy: '' },
      pageTemp: 1,
      pageNumber: 1,
      showAdvancedSearch: false
    }
  },
  computed: {
    ...mapGetters({
      selectedBot: 'selectedBot'
    }),
    tableHeader() {
      return [
        { text: this.$t('follow_up.date'), value: 'start_date', sortable: false },
        { text: this.$t('name'), value: 'name', sortable: false },
        { text: this.$t('channel'), value: 'app', sortable: false },
        { text: this.$t('subject'), value: 'subject', sortable: false },
        { text: this.$t('Description'), value: 'description', sortable: false },
        { text: this.$t('Created by'), value: 'created_by', sortable: false },
        { text: this.$t('created_date'), value: 'created_at', sortable: false },
        { text: this.$t('status'), value: 'status', sortable: false },
        { text: this.$t('follow_up.status.sub_status'), value: 'sub_status', sortable: false },
        { text: '', value: '', sortable: false }
      ]
    },
    pageLength() {
      if (this.total) {
        const total = parseFloat(this.total)
        return Math.ceil(total / this.limit)
      } else {
        return 1
      }
    },
    statusOptions() {
      return [
        { label: this.$t('follow_up.status.pending'), value: 'pending' },
        { label: this.$t('follow_up.status.in_progress'), value: 'in_progress' },
        { label: this.$t('follow_up.status.complete'), value: 'complete' },
        { label: this.$t('follow_up.status.cancel'), value: 'cancel' }
      ]
    },
    subStatusOptions() {
      const tempAllSubStatus = [
        {
          label: this.$t('follow_up.status.pending'),
          value: 'pending_follow_up',
          root: 'pending'
        },
        {
          label: this.$t('follow_up.status.no_answer'),
          value: 'no_answer',
          root: 'in_progress'
        },
        {
          label: this.$t('follow_up.status.rescheduled'),
          value: 'rescheduled',
          root: 'in_progress'
        },
        {
          label: this.$t('follow_up.status.payment_confirmed'),
          value: 'payment_confirmed',
          root: 'complete'
        },
        {
          label: this.$t('follow_up.status.appointment_confirmed'),
          value: 'appointment_confirmed',
          root: 'complete'
        },
        {
          label: this.$t('follow_up.status.rescheduled'),
          value: 'follow_up_next_time',
          root: 'complete'
        },
        {
          label: this.$t('follow_up.status.do_not_contact'),
          value: 'do_not_contact',
          root: 'cancel'
        },
        {
          label: this.$t('follow_up.status.invalid_number'),
          value: 'invalid_number',
          root: 'cancel'
        },
        {
          label: this.$t('follow_up.status.other'),
          value: 'other',
          root: ['in_progress', 'complete', 'cancel']
        }
      ]

      if (this.filter.status) {
        return tempAllSubStatus.filter((item) => item.root.includes(this.filter.status.value))
      }

      return tempAllSubStatus
    }
  },
  mounted() {
    this.handleFetchKmbFollowUpTask()
  },
  methods: {
    async handleFetchKmbFollowUpTask() {
      const vm = this

      try {
        if (!vm.selectedBot.pageid || !vm.selectedDate.start) return

        const tempStartDate = dayjs(vm.selectedDate.start).format('YYYY-MM-DD')
        const tempEndDate = dayjs(vm.selectedDate.end).format('YYYY-MM-DD')

        // const limit = vm.isExport ? vm.total : vm.limit
        // const offset = vm.isExport ? 0 : vm.offset

        const params = {
          page_id: vm.selectedBot.pageid,
          start_date: tempStartDate,
          end_date: tempEndDate,
          limit: vm.limit,
          offset: vm.offset,
          ...(vm.filter.status && { status_list: vm.filter.status.value }),
          ...(vm.filter.created_by && { created_by: vm.filter.created_by }),
          ...(vm.filter.sub_status && { sub_status_list: vm.filter.sub_status.value }),
          ...(vm.filter.search && { search: vm.filter.search })
        }

        const response = await vm.onGetFollowUpTask(params)

        if (response && response.status === 200) {
          const responseData = response.data.data || []

          vm.followUpTaskList = responseData
          vm.total = response.data.total || 0
        }
      } catch (error) {
        console.error(error)
      }
    },
    async onGetFollowUpTask(params) {
      try {
        if (!params) return null

        const response = await kmbApi.getFollowUpTask({
          params
        })

        if (response) {
          return response
        } else {
          return null
        }
      } catch (error) {
        console.error(error)
        return null
      }
    },
    handleChangePage(val) {
      const vm = this
      if (vm.pageTemp !== val) {
        vm.pageTemp = val
        vm.offset = vm.pageNumber * vm.limit - vm.limit

        vm.handleFetchKmbFollowUpTask()
      }
    },
    handleSearch() {
      this.pageNumber = 1
      this.offset = 0
      this.handleFetchKmbFollowUpTask()
    },
    handleClearSearch() {
      this.filter = {
        search: '',
        status: '',
        sub_status: ''
      }

      this.handleSearch()
    },
    onChangeDate() {
      this.handleFetchKmbFollowUpTask()
    },
    handleGoToLiveChat(item) {
      let routeData = this.$router.resolve({
        name: 'allinonechat-new',
        path: '/' + this.currentLang + '/allinonechat-new',
        query: {
          search: item.user_id,
          // inbox: this.value.context == 'contactadmin' ? 'admin' : 'bot',
          app: item.app
        }
      })
      window.open(routeData.href, '_blank')
    }
  }
}
</script>

<style lang="scss" scoped></style>



// WEBPACK FOOTER //
// src/components/view/template/Kmb/FollowUp/FollowUpTable.vue